import { render, staticRenderFns } from "./ProductDesignList.vue?vue&type=template&id=63cac4cd&"
import script from "./ProductDesignList.vue?vue&type=script&lang=js&"
export * from "./ProductDesignList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports